export function getSharedParams({
  page,
  query,
  type,
  date,
  sort,
  perPage,
  initialState,
  editing,
}) {
  const params = {};

  params.perPage = perPage;

  if (!_.isEmpty(query)) params.query = encodeURIComponent(query);

  if (page !== 1) params.page = page;

  if (!_.isEmpty(date)) {
    params.date = {};

    if (!_.isUndefined(date.start) && !_.isNull(date.start))
      params.date.start = date.start;

    if (!_.isUndefined(date.end) && !_.isNull(date.end))
      params.date.end = date.end;
  }

  if (sort.column !== initialState.sort.column) {
    params.sort = {};
    params.sort.column = sort.column;
  }

  if (
    sort.direction !== initialState.sort.direction ||
    initialState.sort.direction === 'desc'
  ) {
    params.sort = params.sort || {};
    params.sort.direction = sort.direction;
  }

  if (type === 'fresh_content') {
    params.sort = {};
    params.sort.column = sort.column || 'freshness-score';
    params.sort.direction = sort.direction || 'asc';
  }

  if (editing === 'true') params.editing = true;

  return params;
}
